import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import Layout from "../components/Layout";
import WeeklyActivityReport from "../components/WeeklyActivityReport";

export default function WeeklyReportPage() {
  const navigate = useNavigate();
  return (
    <Layout>
      <button
        onClick={() => navigate(-1)}
        className="text-sm text-[#9AAEC6] flex items-center gap-1 mb-4 hover:text-white transition-colors"
        data-testid="weekly-report-back"
      >
        <ArrowLeft size={16} /> Back
      </button>

      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="space-y-5"
      >
        <div>
          <div className="bps-eyebrow text-[#22D3EE]">Track the work</div>
          <h1 className="font-display text-3xl font-light tracking-tighter mt-1">Your week, by the numbers.</h1>
          <p className="text-sm text-[#9AAEC6] mt-2 leading-relaxed">
            Every activity you log while wearing the Back Pain Transformer&trade; — broken down by day, category, and habit.
            Reset the pattern, week after week.
          </p>
        </div>

        <WeeklyActivityReport />
      </motion.div>
    </Layout>
  );
}
